<template>
  <div class="loginmgg">
    <div class="login-container"></div>
    <el-form
      :model="ruleForm2"
      :rules="rules2"
      status-icon
      ref="ruleForm2"
      label-position="left"
      label-width="0px"
      class="demo-ruleForm login-page"
    >
      <h3 class="title">找回密码</h3>
      <el-form-item prop="phone">
        <el-input
          type="text"
          v-model="ruleForm2.phone"
          auto-complete="off"
          @keyup.native="phoneChange($event)"
          @change="ChangeNumber"
          placeholder="手机号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="vecode" class="vecodestyle">
        <el-input
          type="text"
          v-model="ruleForm2.vecode"
          auto-complete="off"
          @keyup.native="codeChange($event)"
          @change="Vccode"
          placeholder="请输入验证码"
        ></el-input>
      </el-form-item>
      <el-form-item class="vecodeall">
        <el-button
          type="primary"
          @click="getVerify"
          style="
            width: 105px;
            background: linear-gradient(to right, #97c74e, #2ab9a5);
          "
          :disabled="(disabled = !show)"
          class="baccolor"
        >
          <span v-show="show">获取验证码</span>
          <span v-show="!show" class="count">{{ count }} s</span>
        </el-button>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          type="password"
          v-model="ruleForm2.password"
          auto-complete="off"
          placeholder="请输入新的密码"
        ></el-input>
      </el-form-item>
      <!-- <el-checkbox v-model="checked" class="rememberme">记住密码</el-checkbox> -->
      <el-form-item style="width: 100%">
        <el-button
          type="primary"
          style="
            width: 100%;
            background: linear-gradient(to right, #97c74e, #2ab9a5);
            border: 0;
          "
          :loading="logining"
          @click="handleSubmit"
          >找回密码</el-button
        >
      </el-form-item>
      <span>
        <span class="recolo" @click="hreftologin">返回登录</span>
      </span>
    </el-form>
  </div>
</template>
<script src="https://cdn.jsdelivr.net/npm/js-cookie@2/src/js.cookie.min.js"></script>
<script>
import https from "../http.js";
import qs from "qs";
import $ from "jquery";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      show: true,
      count: "", // 初始化次数
      timer: null,

      logining: false,
      radio: "1",
      ruleForm2: {
        username: "",
        phone: "",
        vecode: "",
        password: "",
        yaoqinphone: "",
      },
      rules2: {
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        vecode: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],

        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      checked: false,
    };
  },
  methods: {
    hreftologin() {
      this.$router.push({ path: "/Login" });
    },
    getVerify(e) {
      // 验证手机号
      if (this.ChangeNumber() == false) {
        return false;
      } else {
        https
          .fetchPost(
            "/site/send",
            qs.stringify({ phone: this.ruleForm2.phone })
          )
          .then((data) => {
            //   console.log(data.data.res_code)
            if (data.data.res_code == 1) {
              sessionStorage.setItem("vecode", data.data.sms);
              // this.$cookie.set('vecode',data.data.sms);
              this.$message.success("发送验证码成功");

              const TIME_COUNT = 60; //更改倒计时时间
              if (!this.timer) {
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(() => {
                  if (this.count > 0 && this.count <= TIME_COUNT) {
                    this.count--;
                  } else {
                    this.show = true;
                    clearInterval(this.timer); // 清除定时器
                    this.timer = null;
                  }
                }, 1000);
              }
            }

            if (data.data == 2) {
              this.$message.error("该手机号码未注册过");
            }
            if (data.data.res_code == 0) {
              this.$message.error("请稍后再试！");
            }
            // console.log(data);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 手机号正整数验证
    phoneChange(e) {
      let flag = new RegExp("^[1-9]([0-9])*$").test(e.target.value);
      if (!flag) {
        this.ruleForm2.phone = "";
      }
    },
    // 验证码正整数验证
    codeChange(e) {
      let flag = new RegExp("^[1-9]([0-9])*$").test(e.target.value);
      if (!flag) {
        this.ruleForm2.vecode = "";
      }
    },
    // 验证码是否长度验证
    Vccode() {},
    ChangeNumber() {
      let phone = this.ruleForm2.phone;
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.$message.error("请填写正确的手机号");
        return false;
      }
    },
    // 提交修改
    handleSubmit(e) {
      var phoned = this.ruleForm2.phone;
      var vecoded = this.ruleForm2.vecode;
      var password = this.ruleForm2.password;
      if (password.length < 6) {
        this.$message.error("密码至少为6位数");
        return false;
      }

      if (phoned == "") {
        this.$message.error("请填写手机号");
        return false;
      }

      if (vecoded == "") {
        this.$message.error("请填写验证码");
        return false;
      }

      if (password == "") {
        this.$message.error("请填写密码");
        return false;
      }
      var param = {
        phone: phoned,
        password: password,
      };
      var vecode = sessionStorage.getItem("vecode");
      // var vecode = this.$cookie.get("vecode");
      //   console.log(vecode)
      if (vecode !== vecoded) {
        this.$message.error("验证码不正确");
        return false;
      }
      https
        .fetchPost("/site/update-pwd", qs.stringify(param))
        .then((data) => {
          //   console.log(data);
          if (data.data.res_code == 0) {
            this.$message.error("修改失败");
          } else if (data.data.res_code == 1) {
            this.$alert("前往登录？", "修改成功", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$router.push({ path: "/login" });
              },
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.loginmgg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.checkboxgg /deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #2ab9a5;
  background: #2ab9a5;
}

.checkboxgg /deep/.el-radio__input.is-checked + .el-radio__label {
  color: #2ab9a5;
}

.registg {
  text-align: left;
  color: #97c74e;
  cursor: pointer;
}

.baccolor {
  background: linear-gradient(to right, #97c74e, #2ab9a5);
  border: 0px;
  color: #fff;
}

.baccolor:hover {
  background: linear-gradient(to right, #97c74e, #2ab9a5);
  color: #fff;
}

.vecodestyle {
  width: 70%;
  display: inline-block;
}

.vecodeall {
  display: inline-block;
}

.recolo {
  color: #2ab9a5;
  cursor: pointer;
}

.login-container {
  /* 加载背景图 */

  background-image: url(../assets/images/zhiyeindex.jpg);

  /* 背景图垂直、水平均居中 */

  /* 背景图不平铺 */

  background-repeat: no-repeat;

  /* 当内容高度大于图片高度时，背景图像的位置相对于viewport固定 */

  background-attachment: fixed;

  /* 让背景图基于容器大小伸缩 */

  background-size: cover;
  position: fixed;
  width: 100%;
  height: 100%;
}
.login-page {
  -webkit-border-radius: 5px;
  border-radius: 5px;
  margin: 180px auto;
  width: 350px;
  padding: 35px 35px 15px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
  position: relative;
  overflow: auto;
}
label.el-checkbox.rememberme {
  margin: 0px 0px 15px;
  text-align: left;
}
</style>
